module.exports = __webpack_public_path__ + "img/1.f1f4dad3.png";